import type { ReactNode } from 'react';

export const symbol_swipe_down_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M469-94q-5-2-10-7L340-220q-9-9-9-21t9-21q9-9 21-9t21 9l68 68v-207q-69-14-119.5-65.5T280-600q0-83 58.5-141.5T480-800q83 0 141.5 58.5T680-600q0 82-50.5 133.5T510-401v207l68-68q9-9 21-9t21 9q9 9 9 21t-9 21L501-101q-5 5-10 7t-11 2q-6 0-11-2Zm110-407q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-99-99Z"
		/>
	</svg>
);
